const routes = {
  home: '/',
  post: '/posts/:postId',
  createPost: '/posts/new',
  page404: '/'
};
export default routes;